export enum JourneyStep {
    VerifyInstitutionalEmail = 2,
    VerifyORCID = 6,
    ConfirmPublications = 7,
    AddPicture = 8
}
